<nz-spin
  *ngIf="isLoading"
  class="fullscreen-spinner"
  [nzSpinning]="true"
  nzSimple
  nzSize="large"
>
</nz-spin>
